"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _react = _interopRequireDefault(require("react"));
var _SIACMSContent = _interopRequireDefault(require("../SIACMSContent/SIACMSContent"));
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
(function () {
  const styles = ":export {\n  primary-SIAblack: #000000;\n  primary-SIAgraydark: #4c4c4c;\n  primary-SIAgrayMiddle: #a8a8a8;\n  primary-SIAgray: #d4d4d4;\n  primary-SIAgrayLight: #e8e8e8;\n  primary-SIAgrayVeryLight: #f4f4f4;\n  primary-SIAwhite: #fff;\n  primary-SIAred: #e41b13;\n  primary-SIAredDark: #99100a;\n  secondary-SIAazure: #8caddb;\n  secondary-SIAazureLight: #e9eff7;\n  secondary-SIAbronze: #b1997e;\n  secondary-SIAbronzeLight: #efebe5;\n  secondary-SIAgreen: #2fb789;\n  secondary-SIAgreenLight: #ecf7f3;\n  secondary-SIAorange: #f3743d;\n  secondary-SIAorangeLight: #fbf1ec;\n  secondary-SIArose: #e6005f;\n  secondary-SIAroseLight: #fcf2f7;\n  secondary-SIAyellow: #dacd7e;\n  secondary-SIAyellowLight: #faf8ed; }\n\n.sia-homepage {\n  display: flex;\n  flex-direction: column;\n  max-width: 66rem;\n  margin: auto; }\n  .sia-homepage .sia-website-layout,\n  .sia-homepage .col_0,\n  .sia-homepage .col_1,\n  .sia-homepage .col_2,\n  .sia-homepage .col_3 {\n    gap: 16px; }\n  .sia-homepage .col_0 {\n    display: flex;\n    flex-direction: column;\n    gap: 16px; }\n  .sia-homepage .sia-page-bottom {\n    display: flex;\n    flex-direction: column;\n    gap: 24px; }\n\n@media (max-width: 66rem) {\n  .sia-page-bottom {\n    padding-inline: 16px; } }\n\n@media (max-width: 42rem) {\n  .sia-homepage .sia-page-bottom {\n    padding-inline: 0px; }\n  .sia-homepage .articleBoxArea-container {\n    padding-inline: 16px; }\n  .sia-homepage .sia-agenda {\n    padding-inline: 16px; } }\n";
  const fileName = "SIAHomepage_SIAHomepage";
  const element = document.querySelector("style[data-sass-component='SIAHomepage_SIAHomepage']");
  if (!element) {
    const styleBlock = document.createElement("style");
    styleBlock.innerHTML = styles;
    styleBlock.setAttribute("data-sass-component", fileName);
    document.head.appendChild(styleBlock);
  } else {
    element.innerHTML = styles;
  }
})();
const SIAHomepage = _ref => {
  let {
    item,
    lang,
    history,
    translate,
    getAgenda
  } = _ref;
  return /*#__PURE__*/_react.default.createElement("div", {
    className: "sia-homepage sia-padding-02-top"
  }, /*#__PURE__*/_react.default.createElement("div", {
    className: "sia-page-bottom"
  }, item?.layout_builder ? /*#__PURE__*/_react.default.createElement(_SIACMSContent.default, {
    items: item.layout_builder,
    lang: lang,
    history: history,
    translate: translate,
    isHomePage: true,
    getAgenda: getAgenda
  }) : /*#__PURE__*/_react.default.createElement("div", null)));
};
var _default = exports.default = SIAHomepage;